import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router';
import RegisteredUsers from './registered/RegisteredUsers';
import GuestUsers from './guest/GuestUsers';
import AllUsers from './all/AllUsers';
import './UsersManagement.css';

const UsersManagement = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  
  // Get tab and search from URL or use defaults
  const [activeTab, setActiveTab] = useState(searchParams.get('tab') || 'registered');
  const [searchTerm, setSearchTerm] = useState(searchParams.get('search') || '');

  // Update URL when tab or search changes
  useEffect(() => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set('tab', activeTab);
    if (searchTerm) {
      newSearchParams.set('search', searchTerm);
    } else {
      newSearchParams.delete('search');
    }
    setSearchParams(newSearchParams);
  }, [activeTab, searchTerm, setSearchParams, searchParams]);

  // Handle tab change
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  // Handle search with debouncing
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <div className="users-management">
      <div className="users-management__header">
        <h2>Manage Users</h2>
      </div>

      <div className="users-management__tabs">
        <button 
          className={`users-management__tab ${activeTab === 'registered' ? 'active' : ''}`}
          onClick={() => handleTabChange('registered')}
        >
          Registered Users
        </button>
        <button 
          className={`users-management__tab ${activeTab === 'guests' ? 'active' : ''}`}
          onClick={() => handleTabChange('guests')}
        >
          Guest Users
        </button>
        <button 
          className={`users-management__tab ${activeTab === 'all' ? 'active' : ''}`}
          onClick={() => handleTabChange('all')}
        >
          All Users
        </button>
      </div>

      <div className="users-management__search">
        <input
          type="text"
          placeholder="Search users..."
          value={searchTerm}
          onChange={handleSearch}
          className="users-management__search-input"
        />
      </div>

      <div className="users-management__content">
        {activeTab === 'registered' && (
          <RegisteredUsers 
            searchTerm={searchTerm} 
            key="registered"
            initialPage={parseInt(searchParams.get('setUser') || '1')}
            onPageChange={(page) => {
              const newSearchParams = new URLSearchParams(searchParams);
              newSearchParams.set('setUser', page.toString());
              setSearchParams(newSearchParams);
            }}
          />
        )}
        {activeTab === 'guests' && (
          <GuestUsers 
            searchTerm={searchTerm} 
            key="guests"
            initialPage={parseInt(searchParams.get('setGuest') || '1')}
            onPageChange={(page) => {
              const newSearchParams = new URLSearchParams(searchParams);
              newSearchParams.set('setGuest', page.toString());
              setSearchParams(newSearchParams);
            }}
          />
        )}
        {activeTab === 'all' && (
          <AllUsers 
            searchTerm={searchTerm} 
            key="all"
            initialPage={parseInt(searchParams.get('setAll') || '1')}
            onPageChange={(page) => {
              const newSearchParams = new URLSearchParams(searchParams);
              newSearchParams.set('setAll', page.toString());
              setSearchParams(newSearchParams);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default UsersManagement; 